// Maps an Ongoing's origin (what it started from) to the icon + colour shown in the
// Ongoing list, the Story header and the timeline — globe for web research, email, etc.
//
// The COLOUR is never written here: an origin IS a module, so it takes the module's one colour from
// @/lib/moduleColors (#210). This file used to carry a fifth, private palette — email #4593c8, task
// #16a34a, note #f59e0b, and BOTH research and event on #3741f3 — so the sidebar drew an event the
// email indigo and a note an amber the rest of the app had already left behind.

// The ICON is no longer written here either: the glyph names came from the same drift the colours
// did — `email`/`tasks`/`notes`/`events` here, `menu-email`/`tick-circle`/`edit`/`calendar-2` in
// the creation strip — so the sidebar drew a different envelope and a different calendar from the
// box directly above it. Both facts now come from the module maps.

import { moduleColor } from '@/lib/moduleColors'
import { moduleIcon } from '@/lib/moduleIcons'

const ORIGIN_META = {
  research: { icon: moduleIcon('research'), color: moduleColor('research'), label: 'Web research' },
  web: { icon: moduleIcon('research'), color: moduleColor('research'), label: 'Web research' },
  email: { icon: moduleIcon('email'), color: moduleColor('email'), label: 'Email' },
  task: { icon: moduleIcon('task'), color: moduleColor('task'), label: 'Task' },
  note: { icon: moduleIcon('note'), color: moduleColor('note'), label: 'Note' },
  event: { icon: moduleIcon('event'), color: moduleColor('event'), label: 'Event' },
  // The sixth module (#210). An ongoing can be started from a contact the same way it is from a
  // task, and without an entry here it fell through to the research globe.
  contact: { icon: moduleIcon('contact'), color: moduleColor('contact'), label: 'Contact' },
  // A story started from a message or a call (busy-timeline-srv#29). The server's origin word is
  // `message`; the module it belongs to is `messaging` (see lib/sources.js for why the words differ).
  message: { icon: moduleIcon('messaging'), color: moduleColor('messaging'), label: 'Message' },
  call: { icon: 'phone', color: moduleColor('messaging'), label: 'Call' },
}

const FALLBACK = ORIGIN_META.research

// `origin` is the stored value; when missing we can infer from data (e.g. has saved research → web).
export function originMeta(origin) {
  if (!origin) return FALLBACK
  return ORIGIN_META[String(origin).toLowerCase()] || FALLBACK
}
